import {
	AllGames,
	BaseBall,
	BasketBall,
	Beginners,
	ContestSizeIcon,
	EntryFeeIcon,
	FootBall,
	H2H,
	HalfWin,
	Hockey,
	Multipliers,
	Rocket,
	Soccer,
	Tournament
} from 'shared/components/icons/icons';
import { IImageMapper, ISVGMapper } from '../interface/createContest';
import MixedLeague from 'assets/images/mixed league.png';
import Bundesliga from 'assets/images/bundesliga-league.png';
import PremierLeague from 'assets/images/premier-league.png';
import UEFALeague from 'assets/images/UEFA-league.png';
import LaLigaLeague from 'assets/images/la-liga-league.png';
import SerieALeague from 'assets/images/serie-A-league.png';
import Ligue1League from 'assets/images/ligue-1-league.png';
import SuperLeague from 'assets/images/super-lig-league.png';
import CommonLeague from 'assets/images/common-league.png';

import {
	FREE,
	TopEightHundred,
	TopFifteen,
	TopFifty,
	TopFive,
	TopFiveThousand,
	TopForty,
	TopFourHundred,
	TopFourThousand,
	TopHundred,
	TopHundredFifty,
	TopOneThousandSixHundred,
	TopOneThousandTwoHundred,
	TopSeventyFive,
	TopSixThousand,
	TopSixty,
	TopTen,
	TopThirty,
	TopThirtyThreeThousand,
	TopThree,
	TopThreeHundred,
	TopThreeThousand,
	TopTwenty,
	TopTwentyFive,
	TopTwo,
	TopTwoHundred,
	TopTwoThousand,
	TopTwoThousandFiveHundred,
	Winner
} from 'shared/components/icons/prizeIcons';
import localizationConstants from 'shared/util/translation/constant';
import { IStatus } from 'features/lobby/interface/lobby';
const isLotteryVersion = process.env.REACT_APP_IS_LOTTERY_VERSION;

const SETTINGS_OPTIONS = [
	{
		title: localizationConstants.entryFee,
		action: 'isEntryFee',
		name: 'entryFee',
		Icon: EntryFeeIcon,
		postFix: ' €',
		visibility: true
	},
	{
		title: localizationConstants.contestSize,
		action: 'isContestSize',
		name: 'contestSize',
		Icon: ContestSizeIcon,
		postFix: '',
		visibility: true
	},
	{
		title: localizationConstants.prizeStructure,
		action: 'isPrizeStructure',
		name: 'prizeStructure',
		Icon: Winner,
		postFix: '',
		visibility: true
	},
	{
		title: localizationConstants.multiEntry,
		action: 'isMultiEntry',
		name: 'multiEntry',
		Icon: Rocket,
		postFix: 'entries',
		visibility: !isLotteryVersion
	}
];

const CONTEST_TYPE_IMAGE_MAPPER: ISVGMapper = {
	Beginner: Beginners,
	Tournament: Tournament,
	'Head to Head': H2H,
	Multipliers: Multipliers,
	'50/50s': HalfWin
};

const CONTEST_MODE_IMAGE_MAPPER: ISVGMapper = {
	Odds: Multipliers,
	Confidence: HalfWin
};

const PRIZE_IMAGE_MAPPER: ISVGMapper = {
	FREE: FREE,
	'50/50': HalfWin,
	'Winner takes all': Winner,
	'Top 1 Win': Winner,
	'Top 2 Win': TopTwo,
	'Top 3 Win': TopThree,
	'Top 5 Win': TopFive,
	'Top 10 Win': TopTen,
	'Top 15 Win': TopFifteen,
	'Top 20 Win': TopTwenty,
	'Top 25 Win': TopTwentyFive,
	'Top 30 Win': TopThirty,
	'Top 40 Win': TopForty,
	'Top 50 Win': TopFifty,
	'Top 60 Win': TopSixty,
	'Top 75 Win': TopSeventyFive,
	'Top 100 Win': TopHundred,
	'Top 150 Win': TopHundredFifty,
	'Top 200 Win': TopTwoHundred,
	'Top 300 Win': TopThreeHundred,
	'Top 400 Win': TopFourHundred,
	'Top 800 Win': TopEightHundred,
	'Top 1200 Win': TopOneThousandTwoHundred,
	'Top 1600 Win': TopOneThousandSixHundred,
	'Top 2000 Win': TopTwoThousand,
	'Top 2500 Win': TopTwoThousandFiveHundred,
	'Top 3000 Win': TopThreeThousand,
	'Top 3300 Win': TopThirtyThreeThousand,
	'Top 4000 Win': TopFourThousand,
	'Top 5000 Win': TopFiveThousand,
	'Top 6000 Win': TopSixThousand
};

const PRIZE_TITLE: IStatus = {
	FREE: localizationConstants.forFee,
	'Winner takes all': localizationConstants.winnerTakesItAll,
	'Top 1 Win': localizationConstants.winnerTakesItAll,
	'Top 2 Win': localizationConstants.top2Win,
	'Top 3 Win': localizationConstants.top3Win,
	'Top 5 Win': localizationConstants.top5Win,
	'Top 10 Win': localizationConstants.top10Win,
	'Top 15 Win': localizationConstants.top15Win,
	'Top 20 Win': localizationConstants.top20Win,
	'Top 50 Win': localizationConstants.top50Win,
	'Top 100 Win': localizationConstants.top100Win,
	'Top 150 Win': localizationConstants.top150Win,
	'Top 200 Win': localizationConstants.top200Win,
	'Top 300 Win': localizationConstants.top300Win,
	'Top 400 Win': localizationConstants.top400Win,
	'Top 800 Win': localizationConstants.top800Win,
	'Top 1200 Win': localizationConstants.top1200Win,
	'Top 1600 Win': localizationConstants.top1600Win,
	'Top 2000 Win': localizationConstants.top2000Win,
	'Top 2500 Win': localizationConstants.top2500Win,
	'Top 3000 Win': localizationConstants.top3000Win,
	'Top 3300 Win': localizationConstants.top3300Win,
	'Top 4000 Win': localizationConstants.top4000Win,
	'Top 5000 Win': localizationConstants.top5000Win,
	'Top 6000 Win': localizationConstants.top6000Win
};

const SPORTS_IMAGE_MAPPER: ISVGMapper = {
	'All sports': AllGames,
	'75c7a82f-8bf8-45ee-8b07-d01c6f811367': Soccer,
	'09ffd1de-7c15-429c-9fa9-4e42be212718': BaseBall,
	'3dfb668e-507f-4cd3-861e-2a2259cae7fe': BasketBall,
	'5f763046-bac9-4d2f-abb6-e6b33cf81250': FootBall,
	'8505f483-92b7-431c-81c8-09e610cf5baa': Hockey
};

const BASKETBALL_ID = '3dfb668e-507f-4cd3-861e-2a2259cae7fe';
const SOCCER_ID = '75c7a82f-8bf8-45ee-8b07-d01c6f811367';

const LEAGUE_IMAGE_MAPPER: IImageMapper = {
	brazil: UEFALeague,
	germany: Bundesliga,
	england: PremierLeague,
	spain: LaLigaLeague,
	italy: SerieALeague,
	france: Ligue1League,
	worldcup: UEFALeague,
	turkey: SuperLeague,
	eurocups: UEFALeague,
	null: CommonLeague,
	india: MixedLeague
};

const HEAD_TO_HEAD = 'Head to Head';

const MODE_TITLE: IStatus = {
	Confidence: localizationConstants.confidence,
	Odds: localizationConstants.odds
};

const TYPE_TITLE: IStatus = {
	Tournaments: localizationConstants.tournaments,
	Tournament: localizationConstants.tournament,
	'Head to Head': localizationConstants.h2h,
	Multipliers: localizationConstants.multipliers,
	'50/50s': localizationConstants.fiftyFifty,
	Beginner: localizationConstants.beginner
};

const TYPE_DESCRIPTION: IStatus = {
	'High-Paying contests with guaranteed prize pools': localizationConstants.tournamentDetails,
	'Compete against a single opponent. Winner takes all': localizationConstants.h2hDetails,
	'Double your money or play for more': localizationConstants.multipliersDetails,
	'Finish in the top half to win': localizationConstants.fiftyFiftyDetails,
	'New to Stippz? Compete with Players of the same experience level': localizationConstants.beginnerDetails
};

const SPORTS_TITLE: IStatus = {
	'All sports': localizationConstants.allSports,
	Soccer: localizationConstants.soccer,
	Baseball: localizationConstants.baseball,
	Basketball: localizationConstants.basketball,
	Football: localizationConstants.americanFootball,
	Hockey: localizationConstants.hockey
};

const MIXED_LEAGUE = 'Mixed League';

export {
	SETTINGS_OPTIONS,
	PRIZE_IMAGE_MAPPER,
	LEAGUE_IMAGE_MAPPER,
	CONTEST_TYPE_IMAGE_MAPPER,
	SPORTS_IMAGE_MAPPER,
	HEAD_TO_HEAD,
	MODE_TITLE,
	TYPE_TITLE,
	TYPE_DESCRIPTION,
	SPORTS_TITLE,
	PRIZE_TITLE,
	MIXED_LEAGUE,
	BASKETBALL_ID,
	SOCCER_ID,
	CONTEST_MODE_IMAGE_MAPPER
};
